module.exports = __webpack_public_path__ + "static/media/cat_earnings_intro.fafc29aa.mp3";